<template>
    <div class="user-courses">
        <h5>Online Courses</h5>
        <table class="table table-hover table-sm mb-0">
            <thead>
            <tr>
                <th class="text-center">Status</th>
                <th>Title</th>
                <th class="text-center">Quiz Score</th>
                <th class="text-center">Progress</th>
                <th>Assigned</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="course in courses"
                :key="course.id"
                class="clickleable"
                @click="open(course)">
                <td width="10%" class="text-center">
                    <div data-toggle="tooltip" data-placement="top" :title="course.online.status">
                       <i class="status-icon fas fa-circle" :class="course.online.slug_status"></i>
                   </div>
                </td>
                <td v-text="course.title"></td>
                <td class="text-center" v-text="course.online.quiz_score"></td>
                <td class="text-center" v-text="course.online.progress"></td>
                <td v-text="shortDate(course.online.assigned_at)"></td>
            </tr>
            </tbody>
        </table>
        <div class="status-icon-legend mb-5">
            <div><i class="fas fa-circle status-icon not_started"></i> Not Started</div>
            <div><i class="fas fa-circle status-icon in_progress"></i> In Progress</div>
            <div><i class="fas fa-circle status-icon quiz_not_completed"></i> Quiz not Completed</div>
            <div><i class="fas fa-circle status-icon completed"></i> Completed</div>
        </div>
    </div>
</template>
<script>
    export default {

        props:{
            user:{
                type: Object,
                required: true,
            },
            redirectUrl: {
                type: String,
                required: false,
                default: '',
            }
        },

        data(){
            return {
                courses: this.user.courses
            }
        },

        methods:{
            open(course){
                if(this.redirectUrl){
                    this.redirectTo(this.redirectUrl);
                    return;
                }
                this.redirectTo(`/admin/courses/${course.slug}?return=/admin/users/${this.user.id}?tab=courses`)
            }
        }
    }
</script>